









import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class FeatureScreenshot extends Vue {
    @Prop()
    imgSrc!: string

    @Prop()
    imgAlt!: string

    @Prop()
    title!: string

    @Prop()
    subtitle!: string
}
